<div class="controls-container">
    <div class="controls-header">Buttons</div>

    <div class="controls-sub-header">Button</div>

    <div>Standard Buttons</div>
    <pm-stack-panel Orientation="Horizontal">
        <pm-button [style.padding-right.px]="5" ButtonClass="button-primary" (click)="OnClick()">Primary</pm-button>
        <pm-button [style.padding-right.px]="5" ButtonClass="button-success">Success</pm-button>
        <pm-button [style.padding-right.px]="5" ButtonClass="button-standard" [tooltip]="buttonTooltip">Standard</pm-button>
        <pm-tooltip #buttonTooltip [Content]="'Button Tooltip'"></pm-tooltip>
    </pm-stack-panel>
    <div>Dialog Buttons</div>
    <pm-stack-panel>
        <pm-button ButtonClass="button-dialog-primary">Primary</pm-button>
        <pm-button ButtonClass="button-dialog-success">Success</pm-button>
        <pm-button ButtonClass="button-dialog-standard">Standard</pm-button>                
    </pm-stack-panel>

    <div>Flat Buttons</div>
    <pm-stack-panel Orientation="Horizontal">
        <pm-button [style.padding-right.px]="5" ButtonClass="button-flat-primary">Primary</pm-button>
        <pm-button [style.padding-right.px]="5" ButtonClass="button-flat-success">Success</pm-button>
        <pm-button [style.padding-right.px]="5" ButtonClass="button-flat-standard">Standard</pm-button>
        <pm-button [style.padding-right.px]="5" ButtonClass="button-flat-transparent">Transparent</pm-button>
    </pm-stack-panel>

    <div>Outline Buttons</div>
    <pm-stack-panel Orientation="Horizontal">
        <pm-button [style.padding-right.px]="5" ButtonClass="button-outline-primary">Primary</pm-button>
        <pm-button [style.padding-right.px]="5" ButtonClass="button-outline-success">Success</pm-button>
        <pm-button [style.padding-right.px]="5" ButtonClass="button-outline-standard">Standard</pm-button>
    </pm-stack-panel>

    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->

    <div class="controls-sub-header">Button Block</div>

    <pm-button-block>PM-Button-Block</pm-button-block>

    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->

    <div class="controls-sub-header">Button Icon</div>

    <pm-stack-panel Orientation="Horizontal">        
        <pm-button-icon [style.margin-right.px]="5">
            <pm-icon-cubes></pm-icon-cubes>
        </pm-button-icon>
        <pm-button-icon [style.margin-right.px]="5" [ButtonClass]="'button-icon-small'">
            <pm-icon-pie-chart></pm-icon-pie-chart>
        </pm-button-icon>
        <pm-button-icon [style.margin-right.px]="5" [ButtonClass]="'button-icon-inline-small'">
            <pm-icon-train></pm-icon-train>            
        </pm-button-icon>
    </pm-stack-panel>

    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->

    <div class="controls-sub-header">Button Dropdown</div>

    <pm-button-dropdown>
        <div class="pm-button layout-flex">Home <pm-icon-down-arrow IconClass="icon-white" *ngIf="!IsExpanded"></pm-icon-down-arrow></div>
        <div class="pm-button-drop-down">
            <pm-context-menu-item>Item 1</pm-context-menu-item>
            <pm-context-menu-item>Item 2</pm-context-menu-item>
        </div>
    </pm-button-dropdown>

    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->
</div>



// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/buttons/buttons.html